import { ExistingClinicMasterProduct } from '../../apis/clinic-master-products/types';
import { ClinicMasterProductSelectorOption } from './interface';

export function isString(value: any): value is string {
  return typeof value === 'string';
}

export function getSelectedOptions(
  clinicMasterProducts: ExistingClinicMasterProduct[],
  selectedClinicMasterProductsIds?: string[],
) {
  const selectedClinicMasterProducts = findSelectedClinicMasterProductsById(
    clinicMasterProducts,
    selectedClinicMasterProductsIds
  );

  return selectedClinicMasterProducts.map(createOption);
}

function findSelectedClinicMasterProductsById(
  clinicMasterProducts: ExistingClinicMasterProduct[],
  selectedClinicMasterProductsIds?: string[]
) {
  return clinicMasterProducts.filter(clinicMasterProduct =>
    isSelected(clinicMasterProduct, selectedClinicMasterProductsIds)
  );
}

function isSelected(clinicMasterProduct: ExistingClinicMasterProduct, selectedIds?: string[]) {
  return selectedIds?.some(selectedId => selectedId === clinicMasterProduct._id);
}

export function createOptions(
  questionnaires: ExistingClinicMasterProduct[],
  selectedClinicMasterProduct?: ExistingClinicMasterProduct | null
) {
  const options: ClinicMasterProductSelectorOption[] = [createEmptyOption()];

  if (selectedClinicMasterProduct) {
    options.push(createOption(selectedClinicMasterProduct));
  }

  return options.concat(mapClinicMasterProductsToOptions(questionnaires));
}

function mapClinicMasterProductsToOptions(
  clinicMasterProducts: ExistingClinicMasterProduct[]
): ClinicMasterProductSelectorOption[] {
  return clinicMasterProducts.map(createOption);
}

function createOption(masterProduct: ExistingClinicMasterProduct): ClinicMasterProductSelectorOption {
  return {
    value: masterProduct._id,
    label: masterProduct.master_medicine.name
  };
}

function createEmptyOption(): ClinicMasterProductSelectorOption {
  return {
    value: null,
    label: 'None'
  };
}
